import { StyledFormGroup } from '@monorepo/shared/componentsV2/styled/form';
import React from 'react';
import {
  StyledConditionLabel,
  StyledConditionProperty,
  StyledConditionsContainer,
  StyledEqualText,
} from './styled';

interface ProjectConditionProps {
  className?: string;
}

export function ProjectCondition({ className }: ProjectConditionProps) {
  return (
    <StyledConditionsContainer className={className}>
      <StyledFormGroup row>
        <div>
          <StyledConditionLabel>Field 1</StyledConditionLabel>
          <StyledConditionProperty content="Site" isLocked />
        </div>
        <StyledEqualText>equals</StyledEqualText>
        <div>
          <StyledConditionLabel>Field 2</StyledConditionLabel>
          <StyledConditionProperty content="Site" isLocked />
        </div>
      </StyledFormGroup>
    </StyledConditionsContainer>
  );
}
